/* Kuori · caixa de compra de la fitxa (snippets/kuori-pdp.liquid, part 'buybox').
   - Pestanyes de marca (només les que hi ha a les opcions del producte) que filtren el desplegable de model.
     El desplegable controla les opcions del selector del tema (que queda amagat), així el preu, la foto, la URL i
     el botó del tema continuen funcionant igual.
   - Sempre hi ha un model triat (David, 22/10/2026): en entrar, el de la URL (?variant=), si no el recordat i si no
     l'iPhone 18 Pro Max (o la primera variant disponible, que és la que porta el tema). En canviar de pestanya de
     marca es tria el primer model disponible d'aquella marca.
   - El model que tria la clienta es recorda (localStorage «kuori:model», el nom del model; la mateixa clau i el mateix
     format que la col·lecció, assets/kuori-cards.js) i es torna a triar en obrir una altra fitxa, en passar de Tough a
     MagSafe i a les col·leccions. El model per defecte (iPhone 18 Pro Max) no es desa: no l'ha triat ella.
   - Galeria: la primera foto és la de la variant triada (snippets/product-gallery); en canviar de model s'hi posa la
     del model nou.
   - El bloc del botó del tema fa de caixa: s'hi posen la part de dalt (.kbox: marques, model, Tough | MagSafe) i la
     de baix (.kbox-end: confiança i «Complétalo»). El botó no es mou (el formulari del tema seguiria funcionant).
   - Finestres petites (<dialog>) de «¿Cuál es mi modelo?» i «¿Qué diferencia hay?».
   - «Complétalo»: productes complementaris de Search & Discovery (o de la col·lecció d'accessoris), via
     sections/kuori-upsell.liquid, amb «Añadir» i «Añadir los dos» per /cart/add.js i la cistella lateral. El
     complement tria sol el model del mòbil de la fitxa si el té (protector de pantalla) fins que la clienta el canvia. */
const root = window.Shopify?.routes?.root || '/';
const MODEL_KEY = 'kuori:model';
const DEFAULT_MODEL = 'iPhone 18 Pro Max';
// Textos en l'idioma de la botiga (snippets/kuori-shop-t, part 'top' de kuori-pdp)
const T = (() => {
  const base = { soldOut: 'agotado' };
  try { return { ...base, ...JSON.parse(document.querySelector('[data-kuori-shop-t]')?.textContent || '{}') }; } catch (e) { return base; }
})();
const getModel = () => { try { return localStorage.getItem(MODEL_KEY) || ''; } catch (e) { return ''; } };
const setModel = (m) => { try { if (m) localStorage.setItem(MODEL_KEY, m); } catch (e) { /* sense emmagatzematge */ } };

// En canviar de variant el tema torna a dibuixar els blocs «liquid» i el selector (product-rerender); del bloc del
// botó només canvia l'element <buy-buttons>. La caixa ja posada es marca (data-mounted) i les còpies noves que
// arriben amb el bloc «liquid» redibuixat s'esborren. Els esdeveniments van delegats al document.
const getBox = () => document.querySelector('[data-kbox][data-mounted]') || document.querySelector('[data-kbox]');
const section = () => document.querySelector('.shopify-section--main-product');
// El selector de marca/model només hi és si la primera opció és el model (data-kbox-models, snippets/kuori-pdp). Si no
// (targeta regal: Importe; Color…), no es toca el selector del tema i les opcions funcionen com sempre.
const hasModels = () => !!document.querySelector('[data-kbox][data-kbox-models]');
const radios = () => {
  if (!hasModels()) return [];
  const vp = section()?.querySelector('variant-picker');
  return vp ? [...vp.querySelectorAll('input[type="radio"][data-option-position="1"]')] : [];
};
// El valor de cada opció és un id; el nom del model és el text de l'etiqueta
const nameOf = (r) => (r?.nextElementSibling?.textContent || r?.value || '').trim();
const brandOf = (name) => {
  const first = (name || '').trim().split(/\s+/)[0] || '';
  return /^iphone$/i.test(first) ? 'iPhone' : first;
};

let activeBrand = '';

// Al DOM només s'hi escriu el que canvia: cada escriptura (també la d'un valor igual) desperta els observadors de la
// pàgina, i amb el personalitzador (que també segueix la secció) es redibuixaven l'un a l'altre a cada fotograma.
const setClass = (el, name, on) => { if (el && el.classList.contains(name) !== on) el.classList.toggle(name, on); };
const setHidden = (el, on) => { if (el && el.hidden !== on) el.hidden = on; };

const renderModels = (box) => {
  const tabs = box.querySelector('[data-kbox-tabs]');
  const select = box.querySelector('[data-kbox-model]');
  if (!select) return;
  const list = radios();
  if (!list.length) { setHidden(box.querySelector('.kbox__top'), true); setHidden(select.closest('.kbox__select'), true); return; }
  const checked = list.find((r) => r.checked);
  const brands = [...new Set(list.map((r) => brandOf(nameOf(r))))];
  // La pestanya és sempre la marca del model triat: en entrar amb un Samsung o un Xiaomi recordat, la pestanya es
  // quedava a iPhone i el desplegable sortia buit (David, 31/10/2026). Una pestanya clicada tria tot seguit un model
  // de la seva marca (firstOf), així que no la desfà.
  if (checked) activeBrand = brandOf(nameOf(checked));
  if (!activeBrand || !brands.includes(activeBrand)) activeBrand = brands[0];

  if (tabs) {
    setHidden(tabs, brands.length < 2);
    const current = [...tabs.children].map((b) => b.dataset.brand).join('|');
    if (current !== brands.join('|')) {
      tabs.replaceChildren(...brands.map((b) => {
        const t = document.createElement('button');
        t.type = 'button';
        t.className = 'kbox__tab';
        t.setAttribute('role', 'tab');
        t.dataset.brand = b;
        t.textContent = b;
        return t;
      }));
    }
    [...tabs.children].forEach((t) => {
      const on = String(t.dataset.brand === activeBrand);
      if (t.getAttribute('aria-selected') !== on) t.setAttribute('aria-selected', on);
    });
  }

  const inBrand = list.filter((r) => brandOf(nameOf(r)) === activeBrand);
  // Només es redibuixa si ha canviat (l'observador també veu aquests canvis)
  const sig = [activeBrand, checked?.value, ...inBrand.map((r) => r.value + r.disabled)].join('|');
  if (select.dataset.sig === sig) return;
  select.dataset.sig = sig;
  select.replaceChildren(...inBrand.map((r) => {
    const o = document.createElement('option');
    o.value = r.value;
    const label = nameOf(r);
    o.textContent = soldOut(r) ? `${label} · ${T.soldOut}` : label;
    return o;
  }));
  if (checked) select.value = checked.value;
};

const soldOut = (r) => r.disabled || r.dataset.optionAvailable === 'false';
// El primer model disponible d'una marca (si cap no ho és, el primer)
const firstOf = (brand) => {
  const inBrand = radios().filter((r) => brandOf(nameOf(r)) === brand);
  return inBrand.find((r) => !soldOut(r)) || inBrand[0];
};

// remember = false: el model per defecte en entrar (no es desa; l'esdeveniment «change» és síncron)
let quiet = false;
const choose = (value, remember = true) => {
  const r = radios().find((x) => x.value === value);
  if (r && !r.checked) {
    r.checked = true;
    quiet = !remember;
    r.dispatchEvent(new Event('change', { bubbles: true }));
    quiet = false;
  }
  if (r && remember) setModel(nameOf(r));
};

/* ---------- Complétalo (es carrega una vegada i es torna a posar si el tema redibuixa la caixa) ---------- */
let upsellItems = null; // es buida en canviar de producte (swapProduct)
const fetchItems = async (url) => {
  const r = await fetch(url);
  if (!r.ok) return [];
  const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
  return [...doc.querySelectorAll('.kup__item')].slice(0, 3).map((n) => n.outerHTML);
};
const loadUpsell = (box) => {
  if (!upsellItems) {
    const id = box.dataset.productId;
    upsellItems = (async () => {
      let items = await fetchItems(`${root}recommendations/products?product_id=${id}&limit=3&intent=complementary&section_id=kuori-upsell`).catch(() => []);
      if (!items.length) items = await fetchItems(`${root}collections/accessories?section_id=kuori-upsell`).catch(() => []);
      return items;
    })();
  }
  upsellItems.then((items) => {
    const up = document.querySelector('[data-kbox-end][data-mounted] [data-kbox-upsell]');
    if (!up || up.dataset.filled) return;
    // Sense complements: es tanca l'espai que se li guardava (assets/kuori-custom.css)
    if (!items.length) { up.dataset.empty = '1'; return; }
    up.dataset.filled = '1';
    up.querySelector('[data-kbox-upsell-list]').innerHTML = items.join('');
    up.hidden = false;
    kupRefresh();
  });
};

// Preu amb el format de la botiga (themeVariables del tema; si no hi és, «12,34€»)
const fmtMoney = (cents) => {
  const f = String(window.themeVariables?.settings?.moneyFormat || '{{amount_with_comma_separator}}€').replace(/<[^>]*>/g, '');
  const n = cents / 100;
  const fix = (dec, th, ds) => {
    const [i, d] = n.toFixed(dec).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
  };
  const map = {
    amount: () => fix(2, ',', '.'), amount_no_decimals: () => fix(0, ',', '.'),
    amount_with_comma_separator: () => fix(2, '.', ','), amount_no_decimals_with_comma_separator: () => fix(0, '.', ','),
    amount_with_apostrophe_separator: () => fix(2, "'", '.'), amount_with_space_separator: () => fix(2, ' ', ','),
  };
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (map[k] || map.amount)());
};
const kupBox = () => document.querySelector('[data-kbox-end][data-mounted] [data-kbox-upsell]');
const kupState = (item) => {
  const o = item.querySelector('[data-kup-select]')?.selectedOptions[0] || item.querySelector('[data-kup-single]');
  return { id: +(o?.value || item.querySelector('[data-kup-add]').dataset.kupAdd), cents: +(o?.dataset.cents || 0), was: +(o?.dataset.centsWas || 0) };
};
// Preu, preu d'abans i % de la variant triada
const kupPaint = (item) => {
  const o = item.querySelector('[data-kup-select]')?.selectedOptions[0];
  if (!o) return;
  item.querySelector('[data-kup-now]').textContent = o.dataset.now;
  const was = item.querySelector('[data-kup-was]');
  was.textContent = o.dataset.was || '';
  was.hidden = !o.dataset.was;
  const off = item.querySelector('[data-kup-off]');
  off.textContent = `-${o.dataset.off}%`;
  off.hidden = !+o.dataset.off;
};
// El mateix model que el mòbil triat a la fitxa, si el complement el té i la clienta no l'ha canviat a mà
const kupModel = (up) => {
  const checked = radios().find((r) => r.checked);
  const model = checked && nameOf(checked);
  if (!model) return;
  up.querySelectorAll('[data-kup-select]').forEach((sel) => {
    if (sel.dataset.touched) return;
    const o = [...sel.options].find((x) => x.dataset.title === model && !x.disabled);
    if (o && sel.value !== o.value) sel.value = o.value;
  });
};
// «Añadir los dos · total» i «Ahorras …» (només amb dues targetes o més)
const kupBoth = (up) => {
  const wrap = up.querySelector('[data-kup-both]');
  if (!wrap) return;
  // Només el que s'afegeix amb un clic (el que s'ha de personalitzar porta a la seva fitxa: data-kup-pers)
  const items = [...up.querySelectorAll('[data-kup-item]:not([data-kup-pers])')];
  if (items.length < 2) { wrap.hidden = true; return; }
  const st = items.map(kupState);
  const total = st.reduce((a, x) => a + x.cents, 0);
  const before = st.reduce((a, x) => a + Math.max(x.was, x.cents), 0);
  const btn = wrap.querySelector('[data-kup-both-add]');
  if (!btn.classList.contains('is-done')) btn.textContent = (items.length === 2 ? wrap.dataset.two : wrap.dataset.all).replace('__PRICE__', fmtMoney(total));
  const save = wrap.querySelector('[data-kup-save]');
  save.textContent = before > total ? wrap.dataset.save.replace('__AMOUNT__', fmtMoney(before - total)) : '';
  save.hidden = !(before > total);
  wrap.hidden = false;
};
const kupRefresh = () => {
  const up = kupBox();
  if (!up || !up.dataset.filled) return;
  kupModel(up);
  up.querySelectorAll('[data-kup-item]').forEach(kupPaint);
  kupBoth(up);
};

// Peces del tema dins la caixa
const keepOne = (selector) => {
  const all = [...document.querySelectorAll(selector)];
  const kept = all.find((n) => n.dataset.mounted) || all[0];
  all.filter((n) => n !== kept).forEach((n) => n.remove());
  return kept;
};
const mount = () => {
  const buyItem = section()?.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
  const box = keepOne('[data-kbox]');
  const end = keepOne('[data-kbox-end]');
  if (!box || !buyItem) return;
  // Fitxes amb el personalitzador de Zepto (plantilla product.pet-lovers): el bloc de l'app va entre el model i el
  // botó. Llavors la part de dalt (tipus de funda i model) es posa just abans del bloc de Zepto (no es mou res de
  // l'app), i l'ordre queda: tipus de funda → model → personalització → «Añadir».
  const pplrItem = section().querySelector('.product-info__block-item:has(> .shopify-app-block .product-personalizer)');
  if (pplrItem && buyItem.compareDocumentPosition(pplrItem) & Node.DOCUMENT_POSITION_PRECEDING) {
    if (box.nextElementSibling !== pplrItem) { pplrItem.before(box); box.dataset.mounted = '1'; }
    setClass(box, 'kbox--solo', true);
  } else if (box.parentElement !== buyItem) { buyItem.prepend(box); box.dataset.mounted = '1'; }
  if (end && end.parentElement !== buyItem) { buyItem.append(end); end.dataset.mounted = '1'; }
  setClass(buyItem, 'kbox-host', true);
  setClass(section(), 'kbox-on', hasModels()); // kbox-on amaga l'opció 1 del selector del tema (kuori-shop.css)
  // Una sola miniatura visible (el tema amaga les fotos d'altres variants): a mòbil no cal la fila de miniatures
  const shown = [...section().querySelectorAll('.product-gallery__thumbnail')].filter((t) => getComputedStyle(t).display !== 'none');
  setClass(section(), 'k-one-media', shown.length <= 1);
  const caseSlot = box.querySelector('[data-kbox-slot="case"]');
  const sel = [...document.querySelectorAll('#caseTypeSelector')].find((n) => !caseSlot.contains(n));
  if (sel) caseSlot.replaceChildren(sel);
  renderModels(box);
  if (document.querySelector('[data-kbox-upsell]')) loadUpsell(box);
};

if (getBox()) {
  mount();
  // Si la URL no porta variant: el model recordat i, si no n'hi ha (o el producte no el té), l'iPhone 18 Pro Max si
  // està disponible. Si no, queda la variant que porta el tema (la primera disponible).
  if (!new URL(window.location.href).searchParams.has('variant')) {
    const remembered = getModel();
    const mine = remembered && radios().find((x) => nameOf(x) === remembered);
    const r = mine || radios().find((x) => nameOf(x) === DEFAULT_MODEL && !soldOut(x));
    if (r && !r.checked) choose(r.value, !!mine);
  }
  // Només la secció del producte (el tema hi redibuixa blocs i selector; swapProduct en canvia el contingut), i no els
  // canvis del personalitzador (shop/personalizer.ts: el seu bloc, la vista prèvia a la galeria i la lupa).
  const ours = (n) => n.nodeType === 1 && !!n.closest?.('[data-kuori-personalizer], canvas.kp-mock, .kp-zoom-open');
  const theirs = (m) => !ours(m.target) && [...m.addedNodes, ...m.removedNodes].some((n) => !ours(n));
  let queued = false;
  new MutationObserver((records) => {
    if (queued || !records.some(theirs)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; mount(); });
  }).observe(section() || document.body, { childList: true, subtree: true });

  document.addEventListener('change', (e) => {
    if (e.target.matches?.('[data-kbox-model]')) { if (e.target.value) { choose(e.target.value); renderModels(getBox()); } return; }
    if (e.target.matches?.('input[data-option-position="1"]') && e.target.checked) { if (!quiet) setModel(nameOf(e.target)); requestAnimationFrame(kupRefresh); }
  });
  document.addEventListener('click', (e) => {
    // Pestanya d'una altra marca: queda triat el primer model disponible d'aquella marca
    const t = e.target.closest('[data-kbox] .kbox__tab');
    if (t) {
      const checked = radios().find((r) => r.checked);
      activeBrand = t.dataset.brand;
      if (!checked || brandOf(nameOf(checked)) !== activeBrand) {
        const r = firstOf(activeBrand);
        if (r) choose(r.value);
      }
      renderModels(getBox());
      return;
    }
    // Tough / Tough MagSafe: són dos productes. Es recorda el model i es canvia la fitxa sense recarregar la pàgina
    const opt = e.target.closest('#caseTypeSelector a.kseg__opt');
    if (opt) {
      const checked = radios().find((r) => r.checked);
      if (checked) setModel(nameOf(checked));
      if (opt.classList.contains('active')) { e.preventDefault(); return; }
      if (e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && swapProduct(opt.href)) e.preventDefault();
    }
  }, true);
}

/* ---------- Galeria: la portada és la foto del model triat ----------
   snippets/product-gallery (data-k-portada) només dibuixa la foto de la variant triada, la primera, i les fotos generals.
   En canviar de variant el tema torna a demanar la secció (product:rerender, que no surt de la fitxa i es mira en la
   fase de captura) però no en redibuixa la galeria: aquí se'n copia la portada nova (foto i miniatura). Es fa després
   del «variant:change» del tema, que cerca a la galeria la foto de la variant nova per anar-hi: encara no hi és i la
   pàgina no es mou. El carrusel torna a la portada sense animació. La vista prèvia del personalitzador
   (canvas.kp-mock, .kp-zoom-open), que va dins la primera foto, no es toca. */
let freshGallery = null;
document.addEventListener('product:rerender', (e) => {
  const g = section()?.querySelector('product-gallery[data-k-portada]');
  freshGallery = g && !e.detail?.productChange ? e.detail?.htmlFragment?.querySelector?.(`product-gallery[form="${g.getAttribute('form')}"]`) : null;
}, true);
document.addEventListener('variant:change', () => {
  const fresh = freshGallery;
  freshGallery = null;
  const g = section()?.querySelector('product-gallery[data-k-portada]');
  if (!fresh || !g) return;
  const swap = (selector) => {
    const cur = g.querySelector(selector);
    const next = fresh.querySelector(selector);
    if (!cur || !next || cur.dataset.mediaId === next.dataset.mediaId) return false;
    [...cur.childNodes].forEach((n) => { if (!n.matches?.('canvas.kp-mock, .kp-zoom-open')) n.remove(); });
    cur.prepend(...[...next.childNodes].map((n) => n.cloneNode(true)));
    cur.dataset.mediaId = next.dataset.mediaId;
    cur.dataset.mediaType = next.dataset.mediaType;
    return true;
  };
  if (swap('.product-gallery__media')) {
    swap('.product-gallery__thumbnail');
    g.carousel?.select(0, { instant: true });
  }
});

/* ---------- Canvi Tough <-> Tough MagSafe sense recarregar ----------
   Es demana la secció principal de l'altre producte (Section Rendering API: /products/<handle>?section_id=<id>) i se
   substitueix el contingut de la secció: galeria, títol, preu, selector, formulari i botó són els del producte nou, així
   que «Añadir» afegeix la variant correcta. Després es torna a triar el model recordat i es canvia la URL
   (history.replaceState). Si la fitxa té el personalitzador (Zepto), que s'injecta en carregar la pàgina, o si alguna
   cosa falla, es fa la navegació normal. */
let swapping = false;
const swapProduct = (href) => {
  const sec = section();
  if (!sec || swapping || !sec.id) return false;
  // Si la fitxa té el personalitzador de Zepto (el seu bloc o el seu botó): navegació normal perquè l'app es torni a
  // carregar amb el producte nou (si se substituís la secció, la personalització del producte nou no sortiria)
  if (document.querySelector('.pplr-c-button, .pplr-wrapper, .product-personalizer, [id^="pplr-"]')) return false;
  const id = sec.id.replace(/^shopify-section-/, '');
  const url = new URL(href, window.location.origin);
  swapping = true;
  sec.setAttribute('aria-busy', 'true');
  const oldTitle = sec.querySelector('.product-title')?.textContent.trim();
  fetch(`${url.pathname}?section_id=${encodeURIComponent(id)}`)
    .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById(sec.id);
      if (!fresh || !fresh.querySelector('form[action$="/cart/add"]')) throw new Error('section');
      // DOMParser no executa scripts i hi llegeix el <noscript> del selector com a HTML de debò: el seu <select name="id">
      // seria un segon camp «id» del formulari, el tema deixaria de canviar la variant (es quedava l'iPhone 18 Pro Max)
      // i el personalitzador no hi trobaria el formulari (25/10/2026, comandes de Doggy Love sense personalitzar).
      fresh.querySelectorAll('noscript').forEach((n) => n.remove());
      upsellItems = null;
      sec.replaceChildren(...[...fresh.childNodes].map((n) => document.importNode(n, true)));
      history.replaceState(history.state, '', url.pathname + url.search);
      const newTitle = sec.querySelector('.product-title')?.textContent.trim();
      if (oldTitle && newTitle) document.title = document.title.replace(oldTitle, newTitle);
      mount();
      const remembered = getModel();
      const r = remembered && radios().find((x) => nameOf(x) === remembered);
      if (r && !r.checked) choose(r.value);
      window.KuoriFav?.sync();
      document.dispatchEvent(new CustomEvent('kuori:product:swapped', { detail: { url: url.pathname } }));
    })
    .catch(() => { window.location.href = href; })
    .finally(() => { swapping = false; sec.removeAttribute('aria-busy'); });
  return true;
};

/* Mostres «+N»: el panell es tanca en clicar fora o amb Esc */
document.addEventListener('click', (e) => {
  document.querySelectorAll('details.ks__drop[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.querySelectorAll('details.ks__drop[open]').forEach((d) => { d.open = false; });
});

/* ---------- Finestres d'ajuda ---------- */
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-kmodal-open]');
  if (open) {
    const d = document.getElementById(open.dataset.kmodalOpen);
    if (d?.showModal) { e.preventDefault(); d.showModal(); }
    return;
  }
  if (e.target.closest('[data-kmodal-close]')) { e.target.closest('dialog')?.close(); return; }
  if (e.target.matches?.('dialog.kmodal')) e.target.close(); // clic fora del contingut
});

/* ---------- Complétalo ---------- */
const addToCart = async (items) => {
  const r = await fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });
  const json = await r.json();
  if (!r.ok) throw new Error(json.description || json.message || 'Error');
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  const drawer = document.getElementById('cart-drawer');
  if (drawer?.show) drawer.show();
  return json;
};

document.addEventListener('change', (e) => {
  const sel = e.target.closest?.('[data-kbox-end] [data-kup-select]');
  if (!sel) return;
  sel.dataset.touched = '1';
  kupPaint(sel.closest('[data-kup-item]'));
  const up = kupBox();
  if (up) kupBoth(up);
});

document.addEventListener('click', async (e) => {
  const one = e.target.closest('[data-kbox-end] [data-kup-add]');
  const both = !one && e.target.closest('[data-kbox-end] [data-kup-both-add]');
  if (!one && !both) return;
  const up = kupBox();
  if (!up) return;
  const items = one ? [one.closest('[data-kup-item]')] : [...up.querySelectorAll('[data-kup-item]:not([data-kup-pers])')];
  const btn = one || both;
  const msg = (one ? items[0] : btn.closest('[data-kup-both]')).querySelector('.kup__msg');
  const label = one ? one.querySelector('[data-kup-label]') : both;
  const done = up.querySelector('[data-kup-both]')?.dataset.added || '';
  msg.textContent = '';
  btn.disabled = true;
  btn.classList.add('is-busy');
  const old = label.textContent;
  try {
    await addToCart(items.map((it) => ({ id: kupState(it).id, quantity: 1 })));
    label.textContent = `✓ ${done}`.trim();
    btn.classList.add('is-done');
    setTimeout(() => {
      btn.classList.remove('is-done');
      label.textContent = old;
      if (both) kupBoth(up);
    }, 2200);
  } catch (err) {
    msg.textContent = err.message;
  } finally {
    btn.disabled = false;
    btn.classList.remove('is-busy');
  }
});
